module.exports = __webpack_public_path__ + "static/media/WoT-warplanes.b34de106.jpg";